import ResourceService from "./resource.service";

class ReservationCategoryService extends ResourceService {
  static get resource() {
    return "reservation-category";
  }
}

export default ReservationCategoryService;
